module.exports = __webpack_public_path__ + "img/border_star.79473841.svg";